import React from "react";
import ReactDOM from "react-dom";

import Search from "./Search";

const searchContainer = document.querySelector(".search-container");

if (searchContainer) {
  ReactDOM.render(
    <Search />, // eslint-disable-line
    searchContainer
  );
}
